import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ParkingType, UserType } from '../utils/utilTypes';
import {
  BookingWithGateDescription,
  getAllUpcomingBookings,
} from '../utils/utilsBooking';

type StateType = {
  parkingBookings: BookingWithGateDescription[];
  userBooking: BookingWithGateDescription | null;

  setParkingBookings: (parking: ParkingType, currentUser: UserType) => void;
  clearParkingBookings: () => void;

  setUserBooking: (userBooking: BookingWithGateDescription) => void;
};
export const useParkingBookingSlice = create<StateType>()(
  devtools(
    (set) => ({
      parkingBookings: [],
      userBooking: null,
      setParkingBookings: (parking: ParkingType, currentUser: UserType) => {
        const flatenedBookings = getAllUpcomingBookings(parking);

        const parkingBookings = flatenedBookings.filter(
          (booking) => booking.user.id !== currentUser?.id
        );

        set({ parkingBookings }, false, 'setParkingBookings');
      },
      clearParkingBookings: () => {
        set({ parkingBookings: [] }, false, 'clearParkingBookings');
      },
      setUserBooking: (userBooking: BookingWithGateDescription) => {
        set({ userBooking }, false, 'setUserBooking');
      },
    }),
    { name: 'Booking Store' }
  )
);
